// cfgmenus

<template>
  	<v-container fluid ma-0 pa-0>
        <v-row no-gutters>
        <v-col cols="12" class="pt-0">
        <v-card tile class="grey darken-3 overflow-hidden">
            <v-app-bar absolute dark dense color="blue-grey darken-2"
                scroll-target="#playground" elevate-on-scroll
            >
				<v-toolbar-title>Menu Config</v-toolbar-title>
                <v-spacer></v-spacer>
				<v-btn small class="ml-3" color="success" :disabled="!isDirty" @click="saveData">Save</v-btn>
	  		</v-app-bar>
            <v-sheet id="playground" class="grey darken-3 overflow-y-auto" max-height="800">
				<v-container fluid style="min-height: 800px;padding-top: 60px">
					<v-row>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="ColumnName" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Title" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Active" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Pos" dense solo hide-details readonly reverse
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Type" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="Group" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                            <v-text-field class="ma-0 pa-0" background-color="grey darken-3" style="font-size: 9pt;"
								value="View" dense solo hide-details readonly
                            ></v-text-field>
                        </v-col>
					</v-row>
					<v-row v-for="(item, index) in items" :key="index">
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0 text-black" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								:value="item.table_name" dense solo hide-details readonly
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.title" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'title_' + index" @keyup.enter="goNext($event, 'title', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
						    <v-switch class="mt-1 ml-3"
                                v-model="item.active" dense solo hide-details color="blue-grey" @change="hasChanged"
                            ></v-switch>				
						</v-col>
						<v-col cols="12" sm="1" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.pos" dense solo hide-details reverse autocomplete="off" @input="hasChanged"
                                :ref="'pos_' + index" @keyup.enter="goNext($event, 'pos', index)"
                                data-comment-id='@focus="$event.target.select()"'
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
                                <v-select class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
                                v-model="item.entry_type" dense solo hide-details :items="toptions" @change="hasChanged"
                                ></v-select>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.group_name" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'group_' + index" @keyup.enter="goNext($event, 'group', index)"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="2" class="pa-0 pt-1 pl-1">
							<v-text-field class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 9pt;"
								v-model="item.view_name" dense solo hide-details autocomplete="off" @input="hasChanged"
                                :ref="'view_' + index" @keyup.enter="goNext($event, 'view', index)"
							></v-text-field>
						</v-col>
					</v-row>
		  		</v-container>
			</v-sheet>
		</v-card>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
        </v-col>
        </v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'cfgmenus',
    components: {
    },
    props: {
    },
    data: () => ({
        loading: false,
        isDirty: false,
        items: [],
        toptions: JSON.parse('["table", "other"]'),
    }),
    computed: {
        ...mapGetters({
            cfgmenus: 'cfgmenus/getCfgMenus',
        }),
    },
    mounted() {
		this.fetchData()
    },
    methods: {
        fetchData() {
            this.loading = true
            let self = this
            this.$store.dispatch('cfgmenus/getCfgMenus')
            .then((response) => {
                //console.log(this.cfglists)
                this.items = JSON.parse(JSON.stringify(this.cfgmenus))
                self.loading = false
            })
            .catch((error) => {
                console.log(error)
                self.loading = false
            });
        },
        hasChanged() {
            this.isDirty = true
            //console.log(this.items)
        },
        saveData() {
			this.loading = true	
            let param = {
                cfgmenus: this.items,
            }
            let self = this
            this.$store.dispatch('cfgmenus/updateCfgMenus', param)
            .then((response) => {
                //console.log(response)
                self.isDirty = false
                self.loading = false
            })
            .catch((error) => {
                console.log('CfgMenus->submit->error')
                console.log(error)
                self.loading = false
            });
        },
        goNext(e, ref, idx) {
            console.log(e, ref, idx)
            //this.$nextTick(() => {
                let nidx = idx + 1
                if(!this.$refs[ref + '_' + nidx]) nidx = 0
                const nextInput = this.$refs[ref + '_' + nidx]
                if (nextInput) {
                    const inputEl = nextInput[0].$el.querySelector('input')
                    //nextInput[0].focus()
                    inputEl.focus()
                    inputEl.select()
                }
            //});
        },
    },
    watch: {
    },
}
</script>

<style>
.text-black .v-text-field__slot input {
   color: #000 !important;
}
</style>